export default "__VITE_ASSET__$Mwt7O3A__"